import { PaginationBody } from '@Entities/pagination'
import * as searchAPI from '@App/api/routes/search'
import { searchPublishers } from '@App/api/routes/search'
import { SearchResultPartyDetails } from '@Entities/party-details'
import SearchCriteriaStore from '@App/stores/search/search-criteria-store'
import { SearchOptionType } from '@App/enum/search-option-type'
import { RequiredCriteria } from '@App/enum/required-criteria'
import { SelectOptionHide } from '@App/stores/search/models/select-option-hide'
import { SearchCriterion } from '@App/stores/search/models/search-criterion'
import { v4 as uuidv4 } from 'uuid'
import { InterestedPartyWithWorkCount } from '@Entities/interested-party-with-work-count'
import { PublisherSearch } from '@App/stores/search/models/publisher-search'
import getPublisherNameAutoCompleteSuggestions from '@App/helpers/search/get-publisher-name-auto-complete-suggestions'
import { Works } from '@Entities/work/works'
import PublicSearchPartyStore from '@App/stores/search/public/public-search-party-store'
import { PartyPage } from '@App/stores/search/party/query-party-store'

export const searchPublishersOptions: Array<SelectOptionHide<PublisherSearch>> = [
    {
        id: uuidv4(),
        value: 'fullName',
        label: 'Publisher Name',
        autoCompleteFetcher: getPublisherNameAutoCompleteSuggestions,
        exactMatchOnly: true,
    },
    { id: uuidv4(), value: 'ipiNameNumber', label: 'Publisher IPI' },
    { id: uuidv4(), value: 'hfaNumber', label: 'MLC Publisher Number' },
]

export const DEFAULT_SEARCH_BY_PUBLISHER_CRITERIA: Array<SearchCriterion<PublisherSearch>> = [
    { id: searchPublishersOptions[0].id, selectedOption: searchPublishersOptions[0], searchTerm: '', isFixed: true },
]

export default class PublicSearchPublishersStore extends PublicSearchPartyStore<PublisherSearch> {
    readonly partySearchScope = 'publisher'

    protected readonly partyLabel = 'Publisher'

    createPublisherSearchCriteriaStore(): SearchCriteriaStore<PublisherSearch> {
        const publisherSearchMaxCriteria = 1
        return new SearchCriteriaStore(
            DEFAULT_SEARCH_BY_PUBLISHER_CRITERIA,
            searchPublishersOptions,
            SearchOptionType.filter,
            RequiredCriteria.first,
            publisherSearchMaxCriteria
        )
    }

    resetSearchCriteriaStore(): void {
        this._currentSearchCriteriaStore = this.createPublisherSearchCriteriaStore()
    }

    get publisherSearch(): PublisherSearch {
        return this.partyQuery
    }

    protected async searchForPartiesApiCall(
        pagination: PaginationBody,
        query: PublisherSearch
    ): Promise<PartyPage<SearchResultPartyDetails>> {
        const publishers = (await searchPublishers(pagination, query)).data
        return {
            parties: publishers.content.map((ip) =>
                PublicSearchPublishersStore.convertInterestedPartyToPartyDetails(ip)
            ),
            count: publishers.totalElements,
        }
    }

    protected async searchWorksForParty(party: SearchResultPartyDetails, pagination: PaginationBody): Promise<Works> {
        const apiResponse = await searchAPI.searchWorksForPublisher(party.ipId ? Number(party.ipId) : 0, pagination)
        return { count: apiResponse.data.totalElements, works: apiResponse.data.content }
    }

    static convertInterestedPartyToPartyDetails(
        interestedParty: InterestedPartyWithWorkCount
    ): SearchResultPartyDetails {
        return {
            ipId: '' + interestedParty.ipId,
            ipiNumber: interestedParty.ipiNumber,
            worksCount: interestedParty.worksCount,
            name: interestedParty.fullName,
            hfaPublisherNumber: interestedParty.hfaNumber,
        }
    }
}
